function normalizeMediaDownloadFileName(fileName?: string | null): string {
  return String(fileName || "")
    .trim()
    .replace(/^"(.*)"$/, "$1");
}

export function appendFileNameToMediaDownloadUrl(
  downloadUrl: string,
  fileName?: string | null,
): string {
  const normalizedFileName = normalizeMediaDownloadFileName(fileName);

  if (!normalizedFileName) {
    return downloadUrl;
  }

  if (/[\\/?#%]/.test(normalizedFileName)) {
    return downloadUrl;
  }

  return `${downloadUrl.replace(/\/+$/, "")}/${normalizedFileName}`;
}

export function buildMediaDownloadPath(
  fileId: string | number,
  fileName?: string | null,
): string {
  const normalizedFileId = String(fileId).trim();
  return appendFileNameToMediaDownloadUrl(
    `/files/download/${normalizedFileId}`,
    fileName,
  );
}

export function buildMediaDownloadUrl(params: {
  fileId: string | number;
  fileName?: string | null;
  baseUrl?: string | null;
}): string {
  const resolvedBaseUrl = String(params.baseUrl || window.location.origin)
    .trim()
    .replace(/\/+$/, "");

  const baseDownloadUrl = new URL(
    `/api/files/download/${String(params.fileId).trim()}`,
    resolvedBaseUrl,
  ).toString();

  return appendFileNameToMediaDownloadUrl(baseDownloadUrl, params.fileName);
}
